import React from "react";
class Config extends React.Component {
          loadConfig(){
               var configMap=new Map();
               configMap.set('requesterId','A0822450215EM');
               configMap.set('recharge-timeout',120);

               return configMap;
          }
}
export default Config;